import React, { useRef } from 'react';
import {
  ListBase,
  ListToolbar,
  Pagination,
  useRefresh,
  Title,
  Datagrid,
  ReferenceField,
  TextField,
} from 'react-admin';

import { Card, makeStyles } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Tooltip from '@material-ui/core/Tooltip';
import CheckIcon from '@material-ui/icons/Check';
import ClearIcon from '@material-ui/icons/Clear';
import DoneIcon from '@material-ui/icons/Done';
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';
import moment from 'moment';
import { useSnackbar } from 'notistack';

import { DialogoConfirmacao } from '../../Components';
import ActionsList from '../../Components/ReactAdmin/ActionsList';
import ActionsField from '../../Components/ReactAdmin/Fields/ActionsField';
import TextoField from '../../Components/ReactAdmin/Fields/TextoField';
import { ProtegerPagina } from '../../layout/VerificaPermissaoPage';
import { api, getUserId } from '../../services';
import {
  PRIMARY_COLOR,
  STATUS_ANDAMENTO_ATIVIDADE_FINALIZADA,
} from '../../utils';
import { PERMISSAO_TELA_ATIVIDADES_GESTOR_LISTAR } from '../../utils/dadosTelas';
import DialogoAvaliacao from './DialogoAvaliacao';
//import ActionsField from './Fields/ActionsField';
import AvaliacaoField from './Fields/AvaliacaoField';
import DataAvaliacaoField from './Fields/DataAvaliacaoField';
import DataEntregaField from './Fields/DataEntregaField';
import DataTerminoField from './Fields/DataTerminoField';
import StatusField from './Fields/StatusField';
import Filter from './Filter';

const StyledTableCell = withStyles((theme) => ({
  head: {
    //backgroundColor: 'green',
    color: 'black',
    //padding: '8px',
    //whiteSpace: 'nowrap',
    //writingMode: 'sideways-lr',
    //textOrientation: 'sideways',
    //width: 'min-content',
    //width: '1px',
    //whiteSpace: 'nowrap',
    //textAlign: 'center',
    //display: 'flex',
    //justifyContent: 'center',
    padding: '2px 5px',
    border: '2px solid black',
    //textAlign: 'center',
    //verticalAlign: 'middle',
  },
  body: {
    //fontSize: 14,
    //whiteSpace: 'nowrap',
    padding: '2px 5px',
    border: '2px solid black',
    //textAlign: 'center',
    //verticalAlign: 'middle',
    //textAlign: 'center',
  },
}))(TableCell);

const useRowStyles = makeStyles({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
});

function formatTempoPrevisto(value) {
  return moment(new Date(value)).format('HH:mm:ss');
}

const useStyles2 = makeStyles((theme) => ({
  pendente: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    color: 'white',
    backgroundColor: '#f44336',
    cursor: 'pointer',
  },
  confirmado: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    color: 'white',
    backgroundColor: '#4caf50',
    cursor: 'pointer',
  },
  cartao: {
    width: theme.spacing(3),
    height: theme.spacing(3),
    color: 'white',
    backgroundColor: '#00796b',
    marginLeft: '10px',
  },
}));

function getDataFormatada(data) {
  if (data) {
    return moment(new Date(data)).format('DD/MM/YYYY - HH:mm');
  }
  return '-';
}

const PostPanel = ({ handleEfetivar = () => {}, ...props }) => {
  const classes = useStyles2();
  return (
    <div>
      <div>
        <span
          style={{
            fontWeight: 'bold',
          }}
        >
          Detalhes:{' '}
        </span>
        {`${
          props.record.atividade.detalhes ? props.record.atividade.detalhes : ''
        }`}
      </div>
      <div style={{ margin: '10px 0px' }}>
        <span
          style={{
            fontWeight: 'bold',
          }}
        >
          Tempo Previsto:{' '}
        </span>
        {`${formatTempoPrevisto(props.record.atividade.tempo_previsto)}`}
      </div>
      <Box mt="1em" />
      {props.record.itens.length > 0 ? (
        <div>
          <Table aria-label="collapsible table" component="div">
            <TableHead>
              <TableRow>
                <StyledTableCell
                  align="left"
                  style={{
                    backgroundColor: PRIMARY_COLOR,
                    color: 'white',
                  }}
                >
                  Status
                </StyledTableCell>
                <StyledTableCell
                  align="left"
                  style={{
                    backgroundColor: PRIMARY_COLOR,
                    color: 'white',
                  }}
                >
                  Horário
                </StyledTableCell>
                <StyledTableCell
                  align="left"
                  style={{
                    backgroundColor: PRIMARY_COLOR,
                    color: 'white',
                  }}
                >
                  Subtarefa
                </StyledTableCell>
                <StyledTableCell
                  align="left"
                  style={{
                    backgroundColor: PRIMARY_COLOR,
                    color: 'white',
                  }}
                >
                  Detalhes
                </StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {props.record.itens.map((row) => {
                const status = row.is_concluido;
                return (
                  <TableRow key={row.id}>
                    <StyledTableCell component="th" scope="row">
                      {status ? (
                        <Tooltip title="" placement="bottom" aria-label="add2">
                          <Avatar
                            className={classes.confirmado}
                            onClick={() => handleEfetivar(row)}
                          >
                            <CheckIcon style={{ fontSize: 15 }} />
                          </Avatar>
                        </Tooltip>
                      ) : (
                        <Tooltip title="" placement="bottom" aria-label="add2">
                          <Avatar
                            className={classes.pendente}
                            onClick={() => handleEfetivar(row)}
                          >
                            <PriorityHighIcon style={{ fontSize: 15 }} />
                          </Avatar>
                        </Tooltip>
                      )}
                    </StyledTableCell>
                    <StyledTableCell component="th" scope="row">
                      {status ? getDataFormatada(row.updated_at) : '-'}
                    </StyledTableCell>
                    <StyledTableCell component="th" scope="row">
                      {row.subAtividade.nome}
                    </StyledTableCell>
                    <StyledTableCell component="th" scope="row">
                      {row.subAtividade.detalhes
                        ? row.subAtividade.detalhes
                        : ''}
                    </StyledTableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
      ) : null}
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  dataHeader: {
    flex: 1,
    backgroundColor: theme.palette.primary.main,
    padding: '10px',
    color: 'white',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
  dataCell: {
    flex: 1,
    padding: '10px',
    fontWeight: 500,
    lineHeight: '1.5rem',
    fontSize: '0.875rem',
    borderSpacing: 0,
    borderCollapse: 'collapse',
  },
}));
//
const MyList = ({ ...props }) => {
  const refresh = useRefresh();
  const refDialogoConfirmacao = useRef(null);
  const { enqueueSnackbar } = useSnackbar();
  const refDialogoAvaliacao = useRef(null);
  const classes = useStyles();

  const handleClose = () => {
    refresh();
  };

  function handleChangeStatusAtividade({ id, andamento }) {
    if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        andamento === STATUS_ANDAMENTO_ATIVIDADE_FINALIZADA
          ? 'Marcar como Não Concluído'
          : 'Marcar como Concluído',
        'Deseja realmente mudar o status dessa atividade?',
        { id, codigo: 1 },
      );
    }
  }

  function handleChangeStatusSubTarefa({ id, is_concluido }) {
    if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        is_concluido ? 'Marcar como Não Concluído' : 'Marcar como Concluído',
        'Deseja realmente mudar o status dessa sub tarefa?',
        { id, codigo: 2 },
      );
    }
  }

  function handleDeletar({ id }) {
    /*if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        'Exclusão de Atividade de Processos',
        'Deseja realmente excluir esta Atividade de Processos?',
        { id, codigo: 3 },
      );
    }*/
  }

  async function changeStatusAtividade(id) {
    const response = await api.put(
      `/instancias_atividades_processos/status/${id}`,
    );
    const { status, message } = response.data;
    if (!status) {
      enqueueSnackbar(`${message}`, {
        variant: 'error',
      });
    }
    handleClose();
  }

  async function changeStatusSubTarefa(id) {
    const response = await api.put(
      `/instancias_subatividades_processos/status/${id}`,
    );
    const { status, message } = response.data;
    if (!status) {
      enqueueSnackbar(`${message}`, {
        variant: 'error',
      });
    }
    handleClose();
  }

  async function removerAvaliacao(id) {
    const response = await api.put(
      `/instancias_atividades_processos/avaliar/${id}`,
      {
        avaliacao: null,
      },
    );
    const { status, message } = response.data;
    if (!status) {
      enqueueSnackbar(`${message}`, {
        variant: 'error',
      });
    }
    handleClose();
  }

  async function deletar(id) {
    //await api.delete(`/instancias_atividades_processos/${id}`);
    //handleClose();
  }

  async function handleConfirma({ id, codigo }) {
    switch (codigo) {
      case 1:
        changeStatusAtividade(id);
        break;
      case 2:
        changeStatusSubTarefa(id);
        break;
      case 3:
        deletar(id);
        break;
      case 5:
        removerAvaliacao(id);
        break;
      default:
        break;
    }
  }

  function handleDesavaliar({ id }) {
    if (refDialogoConfirmacao.current) {
      refDialogoConfirmacao.current.handleOpen(
        'Remover Avaliação',
        'Deseja realmente remover a avaliação da atividade?',
        { id, codigo: 5 },
      );
    }
  }

  function handleAvaliar({ id }) {
    if (refDialogoAvaliacao.current) {
      refDialogoAvaliacao.current.handleOpen(id);
    }
  }

  function verificaDataFutura(data) {
    const dataAtual = new Date(moment().startOf('day').format());
    const dataData = new Date(moment(data).startOf('day').format());

    if (dataAtual.getTime() < dataData.getTime()) {
      return true;
    }

    return false;
  }

  return (
    <>
      <Title title="Atividades Avaliar" />
      <ListToolbar
        filters={props.filters}
        actions={<ActionsList {...props} />}
        {...props}
      />
      <Card style={{ borderRadius: '20px' }} {...props}>
        <Datagrid
          {...props}
          expand={<PostPanel handleEfetivar={handleChangeStatusSubTarefa} />}
        >
          <StatusField
            source="status"
            label="Status"
            sortable={false}
            handleEfetivar={handleChangeStatusAtividade}
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
          />
          <TextoField
            source="atividade.nome"
            label="Título"
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
            //sortable={false}
            sortable={false}
          />
          <TextoField
            source="grau_urgencia"
            label="Urgência"
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
          />
          <TextField
            source="grau_importancia"
            label="Importância"
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
          />
          <ReferenceField
            label="Departamento"
            source="departamento_colaborador_id"
            reference="departamentos_colaborador"
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
            linkType={false}
          >
            <TextField source="nome" />
          </ReferenceField>
          <ReferenceField
            label="Colaborador"
            source="colaborador_id"
            reference="colaboradores"
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
            linkType={false}
          >
            <TextField source="nome" />
          </ReferenceField>
          <DataEntregaField
            source="data_entrega"
            label="Data Entrega"
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
            //sortable={false}
          />
          <DataTerminoField
            source="data_termino"
            label="Data Término"
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
            //sortable={false}
          />
          <AvaliacaoField
            source="avaliacao"
            label="Avaliação"
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
            //sortable={false}
          />
          <ReferenceField
            label="Avaliador"
            source="avaliador_id"
            reference="colaboradores"
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
            linkType={false}
          >
            <TextField source="nome" />
          </ReferenceField>
          <DataAvaliacaoField
            source="data_avaliacao"
            label="Data Avaliação"
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
            //sortable={false}
          />
          <ActionsField
            source="valor"
            textAlign="right"
            label="Ações"
            sortable={false}
            //handleEdit={handleEdit}
            /* handleDeletar={handleDeletar}
            handleDesavaliar={handleDesavaliar}
            handleAvaliar={handleAvaliar} */
            headerClassName={classes.dataHeader}
            cellClassName={classes.dataCell}
            actions={[
              {
                title: 'Desavaliar',
                icon: <ClearIcon />,
                show: (record) =>
                  !verificaDataFutura(record.data_entrega) &&
                  !!record.avaliacao,
                onClick: (record) => handleDesavaliar(record),
              },
              {
                title: 'Avaliar',
                icon: <DoneIcon />,
                show: (record) =>
                  !verificaDataFutura(record.data_entrega) && !record.avaliacao,
                onClick: (record) => handleAvaliar(record),
              },
            ]}
          />
        </Datagrid>
        <TransacoesPagination />
        <DialogoConfirmacao
          ref={refDialogoConfirmacao}
          handleConfirma={handleConfirma}
        />
        <DialogoAvaliacao ref={refDialogoAvaliacao} handleClose={handleClose} />
      </Card>
    </>
  );
};

const ContainerMyList = ({ children, ...props }) => (
  <>
    <ListBase {...props}>
      <MyList {...props} />
    </ListBase>
  </>
);

const TransacoesPagination = (props) => (
  <Pagination rowsPerPageOptions={[10, 20]} {...props} />
);

const List2 = (props) => (
  <ProtegerPagina permissao={PERMISSAO_TELA_ATIVIDADES_GESTOR_LISTAR}>
    <ContainerMyList
      {...props}
      bulkActionButtons={false}
      pagination={<TransacoesPagination />}
      perPage={50}
      filters={<Filter />}
      title="Atividades Avaliar"
      component="div"
      filter={{
        periodoDataEntrega: {
          start: new Date(),
          end: new Date(),
        },
        gestor_id_2: getUserId(),
      }}
    />
  </ProtegerPagina>
);

export default List2;
